import { useForm } from "react-hook-form";

import CustomInput from "../../UI/PageInput/CustomInput";
import CenteredHeading from "../../UI/headingsUI/CenteredHeading";
import GrayButton from "../../UI/buttonUI/GrayButton";
import CustomDescriptionInput from "../../UI/PageInput/CustomDescriptionInput";
import ExpenseViewDialog from "../../UI/viewDialogs/expense/ExpenseViewDialog";
import PrimaryButton from "../../UI/buttonUI/PrimaryButton";
import { CirclePlus } from "lucide-react";
import SearchDropdown from "../../UI/PageInput/SearchDropdown";
import { positiveNumberValidation } from "../../../validations/formValidations";

const AddOvertimeForm = ({ setupData, sendData, loading, successResponse }) => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const { user_id } = watch();

  const onSubmit = (data) => {
    const formData = {
      ...data,
      category_id: 15,
      description: "Overtime - " + data.description,
    };
    sendData(formData, reset);
  };
  return (
    <div className="form-container">
      <CenteredHeading title="Add Overtime" />
      <form
        className="form-border max-w-4xl mx-auto"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <SearchDropdown
          name="user_id"
          label="Received By *"
          keyName="fullName"
          id="id"
          options={setupData}
          value={user_id}
          setValue={setValue}
          control={control}
          error={errors.user_id}
          search={true}
        />
        <CustomInput
          type="number"
          name="amount"
          labelText="Amount *"
          placeholder="Enter"
          register={{
            ...register("amount", {
              ...positiveNumberValidation,
              required: "Please Enter an amount",
            }),
          }}
          error={errors.amount}
        />
        <CustomDescriptionInput
          name="description"
          labelText="Description *"
          register={{
            ...register("description", {
              required: "Please Enter Description",
            }),
          }}
          error={errors.description}
        />
        <div className="flex gap-2 justify-center mt-4">
          <PrimaryButton
            btnText={!loading ? "Add Overtime" : "Adding..."}
            loading={loading}
            Icon={CirclePlus}
            size={18}
          />
          <GrayButton btnText="Cancel" width="w-40" onClick={() => reset()} />
        </div>
      </form>
      {successResponse && (
        <ExpenseViewDialog
          viewDetails={successResponse}
          successMsg="Overtime Successfully Created!"
        />
      )}
    </div>
  );
};
export default AddOvertimeForm;
